
const secureStorage = require('libs/secureStorage')

module.exports = {secureStorage}